import { BaseConditionData } from './base-condition-data';
import { WorkflowConditionTypes } from './Enums/workflow-condition-types';

/**
 * Représente les données d'une condition 'Aucune'.
 */
export class DefaultConditionData extends BaseConditionData {
    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowConditionTypes.None);
    }

    /**
     * Retourne une copie d'une instance de DefaultConditionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: DefaultConditionData) {
        if (!!other) {
            const instance = new DefaultConditionData();
            instance.name = other.name;
            instance.type = other.type;
            instance.id = other.id;
            instance.isMainCondition = other.isMainCondition;

            return instance;
        } else {
            return null;
        }
    }
}
